<div class="app-dialog video-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ video.title }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="onClose()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body video-dialog__body">
    <div class="video-container">
      <iframe
        [src]="safeVideoUrl"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen>
      </iframe>
    </div>
  </div>
</div>
